/**
 * Reshima API client (Option C — hybrid).
 * The backend is our own Python service on the Elestio VM (reshima-api).
 * Owner calls authenticate with the signed-in user's Firebase ID token; secrets
 * never touch the client. Export names/shapes are unchanged from the callable era
 * so pages don't care where the backend lives.
 */
import { auth } from './firebase';
import { API_BASE } from './config';

async function request(path, { method = 'POST', body, authRequired = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (authRequired) {
    const user = auth.currentUser;
    if (!user) throw new Error('sign in required');
    headers.Authorization = `Bearer ${await user.getIdToken()}`;
  }
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = res.statusText;
    try { detail = (await res.json()).detail || detail; } catch { /* keep statusText */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// WhatsApp linking (owner)
export const waCreateInstance = () => request('/api/wa/create-instance');
export const waStatus = () => request('/api/wa/status');
export const waRefreshQr = () => request('/api/wa/refresh-qr');
export const waDisconnect = () => request('/api/wa/disconnect');

// Games (owner)
export const createGame = (cfg) => request('/api/games', { body: cfg || {} });
export const setGameStatus = ({ gameId, status }) =>
  request(`/api/games/${gameId}/status`, { body: { status } });
export const recordBuyIn = ({ gameId, phone, amount, playerName }) =>
  request(`/api/games/${gameId}/buyin`, { body: { phone, amount, name: playerName } });
export const recordCashOut = ({ gameId, phone, amount, playerName }) =>
  request(`/api/games/${gameId}/cashout`, { body: { phone, amount, name: playerName } });
export const seatPlayer = ({ gameId, name, phone }) =>
  request(`/api/games/${gameId}/seat`, { body: { name, phone } });
export const removePlayer = ({ gameId, phone }) =>
  request(`/api/games/${gameId}/remove`, { body: { phone } });

// Public (no auth)
export const getGamePublic = ({ joinCode }) =>
  request(`/api/public/game/${encodeURIComponent(joinCode)}`, { method: 'GET', authRequired: false });
export const claimSeatPublic = ({ joinCode, name, phone }) =>
  request('/api/public/claim', { body: { joinCode, name, phone }, authRequired: false });
